import { FC } from "react";
import classNames from "classnames";

import { SkeletonProps } from "./types";

import styles from "./Skeleton.module.css";



const Skeleton: FC<SkeletonProps> = ({ 
  variant = "rectangular", 
  width, 
  height, 
  className,
  animation = "pulse",
  centered = false
}) => {
  return (
    <div
      className={classNames(
        styles.skeleton,
        styles[`skeleton--${variant}`],
        styles[`skeleton--${animation}`],
        centered && styles['skeleton--centered'],
        className
      )}
      style={{
        width: width,
        height: height
      }}
    />
  );
};

export default Skeleton; 